(function() {

/* ENV */
const hostname = window.location.hostname;
const site = (hostname == "bunseed.local" ? "http://bunseed.local" : "https://"+hostname);
const core = (hostname == "bunseed.local" ? "http://core.bunseed.local" : "https://core."+hostname.replace("2.", ""));
const type = document.body.classList.contains("post-template") ? "single-post" : 
             document.querySelector('.post-feed') && document.querySelector('.post-feed').classList.contains('my-list') ? "MyList" :
             document.querySelector('.post-feed') && document.querySelector('.post-feed').classList.contains('my-history') ? "PlayerHistory" :
             document.querySelector('.post-feed') && document.querySelector('.post-feed').classList.contains('my-purchases') ? "MyPurchases" : null;
const postID = (type == "single-post" ? document.querySelector('.single-post').dataset.id : null);
const urlParams = new URLSearchParams(window.location.search);
const payment = urlParams.get('payment');
let player;
let memberData = {};
if (member){
memberData.rights = (sessionStorage.getItem('memberRights') && isJsonString(sessionStorage.getItem('memberRights'))) ? JSON.parse(sessionStorage.getItem('memberRights')) : null;
}

/* ========= CLASSES =========== */

class LocalStorageList {

    constructor(storageKey) {
        this.storageKey = storageKey;
        this.list = [];
        this.init(); // Async initialization method
    }

    async init() {
        if (member) {
            this.list = JSON.parse(sessionStorage.getItem(this.storageKey) || '[]');
        } else {
            this.list = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
        }
    }

    replace(data) {
        if (data == "undefined"){ // If first logging in, get local list
            this.list = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
            this.syncWithLocalStorage();
        }
        else {
            this.list = (data !== undefined ? JSON.parse(data) : []);
            this.syncWithLocalStorage(false);
        }
    }

    add(data) {
        let existingIndex = this.list.findIndex(post => post.id === data.id);
        if (existingIndex > -1) {
            this.list[existingIndex] = data;
        } else {
            this.list.push(data);
        }
        this.syncWithLocalStorage();
    }

    get(postid) {
        let post = this.list.find(post => post.id === postid);
        return post || null;
    }

    delete(postid) {
        this.list = this.list.filter(post => post.id !== postid);
        this.syncWithLocalStorage(true,true);
    }

    deleteAll() {
        this.list = [];
        this.syncWithLocalStorage(true,true);
    }

    syncWithLocalStorage(online = true,escapeThrottle = false) {

        if (this.storageKey == "MyList"){

            updateList(this.storageKey,JSON.stringify(this.list),online);

        }
        else if (this.storageKey == "PlayerHistory"){

            if (escapeThrottle) {
                updateList(this.storageKey,JSON.stringify(this.list),online);
            } else {
                throttledUpdateList(this.storageKey,JSON.stringify(this.list),online);
            }

        }
    }
}
class PlayerHistory extends LocalStorageList {
    constructor() {
        super("PlayerHistory"); // call the super class constructor and pass in the name argument
        if (PlayerHistory.instance) { return PlayerHistory.instance; }
        PlayerHistory.instance = this;
    }
}
class MyList extends LocalStorageList {
    constructor() {
        super("MyList"); // call the super class constructor and pass in the name argument
        if (MyList.instance) { return MyList.instance; }
        MyList.instance = this;
    }
}
let playerHistory = new PlayerHistory();
let myList = new MyList();

function populateData(type){
    document.querySelectorAll('article.post').forEach(function(article) {
        enhanceDOMarticle(article,type);
    });
}
populateData();

/* ========== MEMBER DATA =========== */

if (member){

    /* SI PAS DE SESSION STORAGE : FETCH */
    if (
        (!sessionStorage.getItem('session') || Date.now() - 3600000 > parseInt(sessionStorage.getItem('session')))
        || window.performance.getEntriesByType("navigation")[0].type === "reload"
        || urlParams.get('action')
    ) {
        if (VOD) {
            fetch_memberList("all+vod");
        } else {
            fetch_memberList("all");
        }
        sessionStorage.setItem('session', Date.now()); // Adds 1 hour to current time
    }
    /* SI SESSION STORAGE : FETCH PAS */
    /* SI PAIEMENT : FETCH RIGHTS */
    else if (VOD && payment) {
        fetch_memberList("rights");
    }
}

/* =========== LISTS ============== */

if (type == "MyList" || type == "PlayerHistory" || type == "MyPurchases"){
    fetch_list().then((articles) => {

        addPoststoFeed(articles);

    }).catch(error => {
        // Erreur
        console.error(error);
    });
}


/* ============ EVENTS DATA ============ */

// MEMBER RIGHTS
document.addEventListener("memberRightsReady", function(event) {
    populateData("sells");

});

// MEMBER MY LIST
document.addEventListener("memberMyListReady", function(event) {

});

// MEMBER HISTORY
document.addEventListener("memberPlayerHistoryReady", function(event) {
    populateData("playback");
});

/* ============ FONCTIONS ============ */
function slugify(str) {
    if (str !== undefined){
        str = str.replace(/^\s+|\s+$/g, ''); // enlever les espaces en début et fin de chaîne
        str = str.toLowerCase(); // convertir tous les caractères en minuscules
        str = str.replace(/[^\w\s-]/g, ''); // enlever tous les caractères qui ne sont pas des lettres, des chiffres, des espaces ou des tirets
        str = str.replace(/[\s_-]+/g, '-'); // remplacer les espaces et les tirets par des tirets
        return str;
    }
    return '';
}
function transform_tagToDate(tag){

    // Check if tag is a date
    if (!tag.startsWith("tag-hash-date-")){
        throw new Error('Invalid Date class');
    }

    // tag arrive sous format tag-hash-date-YYYY-MM-DD-hh-mm
    const parts = tag.split('-');

    // S'assurer que la longueur est correcte
    if (parts.length != 8) { 
        return null;
    }

    const year = parts[3];
    const month = parts[4];
    const day = parts[5];
    const hour = parts[6];
    const minute = parts[7];

    // Date
    return year+'-'+month+'-'+day+' '+hour+':'+minute;
}
function parseSellValues(value) {
    // Initialiser les valeurs par défaut
    let tag = value;
    let type = '';
    let period = false;
    let currency = '';
    let amount = 0;
    let pwyw = false;
    let pwyw_amount = 1;
    let serie = false;

    let label = '';
    let title = '';
    let button = '';

    let remainingValue = value.replace('tag-hash-','');

    // Split by '-' to extract components
    let components = value.split('-');

    // Extraire le type
    type = components.filter(item => ['buy', 'rent', 'crowdfunding'].includes(item))[0];
    if (type) {
        let typeIndex = components.indexOf(type);
        let nextComponent = components[typeIndex + 1];

        // Si le prochain élément après le type n'est pas un montant, retourner false
        if (!nextComponent || !/^\d+([a-zA-Z]+)$/.test(nextComponent)) {
            return false;
        }
        remainingValue = remainingValue.replace(type, '');
    }

    // Extraire le montant et la monnaie
    let amountComponent = components.find(item => /(\d+([a-zA-Z]+))$/.test(item));
    if (amountComponent) {
        currency = currencyToSymbol( amountComponent.match(/[a-zA-Z]+$/)[0] );
        amount = parseFloat(amountComponent.replace(currency, ''));
        remainingValue = remainingValue.replace(amountComponent, '');
    }

    // Extraire period pour les locations
    let periodRegex = /(\d+h|\d+d|\d+w)/;
    let periodComponent = components.find(item => periodRegex.test(item));
    if (periodComponent) {
        period = periodComponent;
        remainingValue = remainingValue.replace(periodComponent, '');
    }

    // Vérifier si pwyw est présent et extraire le montant correspondant
    let pwywIndex = components.indexOf('pwyw');
    if (pwywIndex !== -1) {
        pwyw = true;
        if (components.length > pwywIndex + 1 && /^\d+/.test(components[pwywIndex + 1])) {
            pwyw_amount = parseFloat(components[pwywIndex + 1].replace(/[a-zA-Z]+$/, ''));
            pwyw_amount = Number(pwyw_amount) < 0.5 ? 1 : pwyw_amount;
            remainingValue = remainingValue.replace(components[pwywIndex + 1], ''); // Remove the amount from remaining value
        }
        remainingValue = remainingValue.replace('pwyw', '');
    }


    // Après avoir retiré tous les éléments reconnus, ce qui reste est le slug de la série
    remainingValue = remainingValue.replace(/-+/g, '-'); // Remplacer les multiples '-' par un seul
    if (remainingValue.startsWith('-')) {
        remainingValue = remainingValue.slice(1);
    }
    if (remainingValue.endsWith('-')) {
        remainingValue = remainingValue.slice(0, -1);
    }

    if (remainingValue) {
        serie = remainingValue;
    }


    // LABEL / TITLE
    if (type == "buy"){
        label   = pwyw ? " Prix libre" 
                :  " Acheter "+amount+currency;

        title   = pwyw ? "Acheter à prix libre"+ ( pwyw_amount != 0 ? " (à partir de " + pwyw_amount + currency + ")" : "" )
                : "Acheter "+amount+currency;

        button  = pwyw ? "Acheter à prix libre"
                : "Acheter "+amount+currency;
        
    }
    else if (type == "rent"){
        label   = pwyw ? " Prix libre"
                : " Louer "+amount+currency;

        title   = pwyw ? "Louer à prix libre"+ ( pwyw_amount != 0 ? " (à partir de " + pwyw_amount + currency + ")" : "" ) +" pendant "+period.replace("d"," jours").replace("w"," semaines")
                : "Louer "+amount+currency+" pendant "+period.replace("d"," jours").replace("w"," semaines");

        button   = pwyw ? "Louer à prix libre ("+period.replace("d"," jours").replace("w"," semaines")+")" 
                : "Louer "+amount+currency+" ("+period.replace("d"," jours").replace("w"," semaines")+")";
    }


    return {
        tag,
        type,
        period,
        currency,
        amount,
        pwyw,
        pwyw_amount,
        serie,
        label,
        title,
        button
    };
}
function currencyToSymbol(cur) {
    const currencyMap = {
        'eu': '€',
        'usd': '$',
        'gbp': '£',
        'cad': '$',
        'aud': '$',
        'jpy': '¥',
    };

    return currencyMap[cur] || cur; // Si la devise n'est pas trouvée, retournez la devise elle-même
}
function simplifyDuration(duration) {
    let parts = duration.split(':');
    if (parts[0] == 0) { parts.shift(); }
    if (parts.length == 3) {
        return Math.round(parts[0]) + ":" + parts[1] + ":" + parts[2];
    } else {
        return Math.round(parts[0]) + ":" + parts[1];
    }
}
function formatDate(dateString) {
    // This function should format the date as needed, for example:
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
}
const debounce = (fn) => {
    let frame;
    return (...params) => {
      if (frame) { 
        cancelAnimationFrame(frame);
      }
      frame = requestAnimationFrame(() => {
        fn(...params);
      });
    } 
};
function throttle(func, delay) {
    let lastCall = 0;
    return function(...args) {
      const now = (new Date()).getTime();
      if (now - lastCall < delay) {
        return;
      }
      lastCall = now;
      return func(...args);
    };
}
function decodeHtmlEntities(text) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
}
function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

// SINGLE POST
if (type == 'single-post'){
    
    // IF NOT A BLOG POST
    if (!document.querySelector('.single-post').classList.contains('tag-blog')){
    
        // NO ACCESS or VOD
        if (VOD && member && document.querySelector('.single-post').classList.contains('noaccess') && !document.querySelector('body').classList.contains('videaste_player')){
            // Get VOD
            fetch_vodHTML();
        }
        
        // ACCESS
        else {
            // PLAYER
            bunseed_player();
        }
    }

    // Suggestions
    create_suggestions();

    postActions_addData();
    document.addEventListener("memberDataReady", function(event) {
        postActions_addData("member");
    });
    
}

// Create Carousels (JQUERY)
carousel();

// Create Friends Carousels
create_friendsCarousels();

// Activate Social buttons
postActionsButton();

// Active my list button
myListActions();

// Activate Keyboard Navigation (JQUERY)
keyboardNav();

// Remove DOM not access for member
removeUnaccessDom();

// Activate Pay
pay();


store_scrollPosition();


/* =========== ORCHESTRATEURS =========== */

// Create friends Carousels
function create_friendsCarousels() {
    const friendsElements = document.querySelectorAll('.friends');
    if (friendsElements.length === 0) { return; }

    friendsElements.forEach(async friendsElement => {
        const friendscarousel = friendsElement.querySelector('.carousel');
        let sortType = friendsElement.getAttribute('data-sort');
        let sites = JSON.parse(friendsElement.getAttribute('data-site'));

        let ghostFriendsApi = [];
        let posts = [];

        sites.forEach(item => {
            if (Object.keys(item).length === 0) {
                return;
            }

            if (item.key && !item.key.includes("http://") && !item.key.includes("https://")) {
                ghostFriendsApi.push(item);
            }
        });

        if (ghostFriendsApi.length) {
            if (ghostFriendsApi.length == 1 && ghostFriendsApi[0].key.includes("&order")) {
                sortType = "none";
            }

            let fetchPromises = ghostFriendsApi.map(async site => {
                const friendPosts = await fetch_friendPosts(site);
                friendPosts.forEach(post => {
                    posts.push(createArticle(post, site));
                });
            });

            await Promise.all(fetchPromises);
        }

        // Sorting
        switch (sortType) {
            case 'asc':
                posts.sort((a, b) => new Date(a.isoDate) - new Date(b.isoDate));
                break;
            case 'desc':
                posts.sort((a, b) => new Date(b.isoDate) - new Date(a.isoDate));
                break;
            case 'none':
                break;
            default:
                posts.sort(() => 0.5 - Math.random());
        }

        addPoststoCarouel(friendscarousel, posts);
    });
}
// Create or Remove playlist
function loadPlaylist(){
    const playlistCarousel = document.querySelector('.playlist');
    if (type == "single-post" && playlistCarousel) {


        // If less than 2 videos : Remove playlist
        if (playlistCarousel.querySelectorAll('article').length < 2){
            playlistCarousel.closest('.gh-outer').remove();
        }
        // If more than 1 videos
        else { 

            const $playlistCarousel = $(playlistCarousel);

            // FIND CURRENT ARTICLE PLAYED
            if (!$playlistCarousel.find('article.current').length){
                $playlistCarousel.find('article[data-id="'+$('.single-post').data('id')+'"]').addClass('current');
            }
            $playlistCarousel.trigger('to.owl.carousel',[
                $playlistCarousel.find('article.current').parent().index(),
                0
            ]);

            // FIND NEXT VIDEO
            const nextVideo =   $playlistCarousel.hasClass('owl-loaded') ?
                                $playlistCarousel.find('article.current').parent().next().find('article'):
                                $playlistCarousel.find('article.current').next();

            if (nextVideo.length && $('body').hasClass("videaste_player") && !$("article.single-post").hasClass("tag-hash-autoplay-off")){
                var autoplay = localStorage['autoplay'] == 'false' ? false : true;
                // Create next button
                document.querySelector('.single-post .post-media.post-main .js-reframe').insertAdjacentHTML('beforeend',
                `<div class="nextbutton">
                    <div class="autoplay">Lecture automatique <label class="switch"><input type="checkbox" `+ (autoplay ? 'checked' : '') +`><span class="slider round"></span></label></div>
                    <div class="nextvideo"></div>
                </div>`);
                // Add article in next button
                $('.single-post .post-media.post-main .nextvideo').append(nextVideo.clone());

                $('.autoplay input').change(function() {
                    localStorage['autoplay'] = this.checked ? true : false;
                });
            }

        }
    }
}
// Create suggestion carousel
function create_suggestions(){
    const suggestEl = document.querySelector('.suggest');
    if (suggestEl){
        fetch_suggestions().then((articles) => {
            if (articles.length <2){
                suggestEl.closest('.gh-outer').remove();
            } else {
                addPoststoCarouel(suggestEl,articles);
            }
        }).catch(error => {
            console.error(error);
            suggestEl.closest('.gh-outer').remove();
        });
    }
}


/* ========== EVENTS =========== */

// When window resize 
window.addEventListener('resize', function() {

    // Recreate Carousels
    if (document.querySelectorAll('.owl:not(.owl-loaded)').length) {
        carousel();
    }
    // Resize Chat
    resizeChat();
});
// Keyboard Nav (JQUERY)
function keyboardNav(){

    // enlever la sélection par défaut des liens
    $('article:not(.single-post) a').not('[tabindex="0"]').attr('tabindex','-1');
    // ajouter la sélection pour les menus
    $('.gh-head-brand a, .gh-head-brand button, .gh-head-menu a, .gh-head-menu button, .gh-head-actions a, .gh-head-actions button, .gh-foot-menu a').attr('tabindex','0');
        
    
    $.fn.itemFocus = function() { if ($(this).data('index') !== undefined){
        $('[tabindex="0"].focus').removeClass('focus');
        if (!$(this).parent().is('.active')){
            $(this).closest('.carousel').trigger('to.owl.carousel',[
                $(this).parent().index(),
                0
            ]);
        }
        $(this).addClass('focus').focus();
    
        let focusItems = JSON.parse(sessionStorage.getItem('FocusItems')) || [];
        let currentUrlEntry = focusItems.find(item => item.url === window.location.href);
    
        let newEntry = {
            url: window.location.href,
            index: $(this).data('index'),
        };
    
        if (currentUrlEntry) {
            currentUrlEntry.index = newEntry.index;
        } else {
            focusItems.push(newEntry);
        }
    
        sessionStorage.setItem('FocusItems', JSON.stringify(focusItems));
    }};
    
    $(document).keydown(function(e) {
        const keyCodes = {
            left: 37,
            up: 38,
            right: 39,
            down: 40,
            enter: 13
        };
    
        if (Object.values(keyCodes).includes(e.keyCode)) {
    
        if (e.keyCode === keyCodes.enter && $(':focus').length) {
            if ($(':focus').is('article')){
                window.location = $(':focus').find('a').first().attr('href');
            }
        } else {
    
            let focusableItems = $('[tabindex="0"]:visible');
            focusableItems.each(function(index) {
                $(this).data('index', index);
            });
    
            let focusItems = JSON.parse(sessionStorage.getItem('FocusItems')) || [];
            let currentUrlEntry = focusItems.find(item => item.url === window.location.href);
            let focusedIndex = currentUrlEntry ? currentUrlEntry.index ? currentUrlEntry.index : $('article[tabindex="0"]').first() ? $('article[tabindex="0"]').first().data('index') : 0 : $('article[tabindex="0"]').first() ? $('article[tabindex="0"]').first().data('index') : 0;
            
    
            let itemToFocus = focusableItems.filter(function() {
                return $(this).data('index') === focusedIndex;
            }).first();
    
        if ($('[tabindex="0"].focus').length){
    
            let itemToFocusCarousel = itemToFocus.closest('.gh-outer') ? itemToFocus.closest('.gh-outer') : null;
    
            
            let newFocusedIndex = -1;
            if (e.keyCode === keyCodes.right || e.keyCode === keyCodes.down) {
                newFocusedIndex = Math.min(focusedIndex + 1, focusableItems.length - 1);
            } else if (e.keyCode === keyCodes.left || e.keyCode === keyCodes.up) {
                newFocusedIndex = Math.max(focusedIndex - 1, 0); 
            }
    
            if (newFocusedIndex >= 0){
                itemToFocus = focusableItems.filter(function() {
                    return $(this).data('index') === newFocusedIndex;
                }).first();
            }
    
            if (itemToFocusCarousel && window.matchMedia("(min-width: 768px)").matches){
                if ((e.keyCode === keyCodes.up && itemToFocusCarousel.prev().find('[tabindex="0"]').length > 0) 
                    || (e.keyCode === keyCodes.down && itemToFocusCarousel.next().find('[tabindex="0"]').length > 0)) {
                    itemToFocus = (e.keyCode === keyCodes.up ? itemToFocusCarousel.prev().find('[tabindex="0"]').first() : itemToFocusCarousel.next().find('[tabindex="0"]').first());
                }
            }
        
        }
            
            itemToFocus.itemFocus();
    
            e.preventDefault();
        }
        } 
    
    });
    
}
// Actions of socials buttons
function postActionsButton(){

    // DON
    document.querySelectorAll('#actions .give a').forEach(function(element) {
        element.addEventListener('click', function(event) {
            var left = (screen.width - 550) / 2;
            var top = (screen.height - 650) / 2;
            window.open(this.getAttribute('href'), "_blank", "toolbar=no,scrollbars=yes,resizable=yes,top=" + top + ",left=" + left + ",width=550,height=600");
            event.preventDefault();
        });
    });

    // SHARE
    if (navigator.share) {
        document.querySelectorAll('#actions .share a').forEach(element => {
            element.addEventListener('click', function(event) {
                navigator.share({
                    title: this.dataset.title,
                    text: this.dataset.text,
                    url: this.dataset.url
                })
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error sharing', error));
    
                event.preventDefault();
            });
        });
    } else {
        document.querySelectorAll('#actions .share a').forEach(element => {
            element.addEventListener('click', function(event) {
                var left = (screen.width - 550) / 2;
                var top = (screen.height - 650) / 2;
                window.open(this.getAttribute('href'), "_blank", "toolbar=no,scrollbars=yes,resizable=yes,top=" + top + ",left=" + left + ",width=550,height=600");
                
                event.preventDefault();
            });
        });
    }

    // COMMENT SCROLL (USELESS IF GHOST COMMENT DESACTIVATED)
    document.querySelectorAll('#actions .comment a[href="#comments"]').forEach(function(element) {
        element.addEventListener('click', function(e) {
            e.preventDefault();
            var commentsElement = document.querySelector("#comments");
            var iframeFormElement = commentsElement.querySelector('iframe').contentWindow.document.querySelector('form');
            var bodyPaddingTop = getComputedStyle(document.body).paddingTop;
            var scrollTopValue = commentsElement.getBoundingClientRect().top + iframeFormElement.getBoundingClientRect().top - parseInt(bodyPaddingTop, 10) + window.scrollY;
    
            window.scrollTo({ top: scrollTopValue, behavior: 'smooth' });
            
            var formEvent = new Event('click');
            iframeFormElement.dispatchEvent(formEvent);
        });
    });
    
}
// My list
function myListActions(){
    var favLink = document.querySelector('#actions span.fav a');
    if (favLink) {

        var article = document.querySelector('article');
        var state = myList.get(article.dataset.id);

        if (state){
            favLink.classList.add('added');
            favLink.setAttribute('title', 'Retirer de ma liste');
        }

        favLink.addEventListener('click', function(event){
            event.preventDefault();
            var id = this.closest('article').dataset.id;
            if (this.classList.contains('added')){
                myList.delete(id);
                this.classList.remove('added');
                this.setAttribute('title', 'Ajouter à ma liste');
            }
            else {
                myList.add({'id': id, 'time': Date.now()});
                this.classList.add('added');
                this.setAttribute('title', 'Retirer de ma liste');
            }
        });
    }
}
// VOD Pay
function pay() {
    document.querySelectorAll(".gh-sell").forEach(button => {
        button.addEventListener("click", function() {

            if (button.classList.contains("loading")) return null;

            if (button.classList.contains('active') && member){
                this.classList.add("loading");
                document.body.style.cursor = 'progress';

                fetch(core + '/flows/trigger/02489e27-102d-45fc-85a7-9aed8163431f', {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        postid: document.querySelector('.post.single-post').dataset.id,
                        tag: this.dataset.session/*,
                        memberid: memberData.uuid,
                        memberemail: memberData.email*/
                    }),
                })
                .then(response => response.json())
                .then(data => {
                    if (!data.session_url) {
                        throw new Error(data);
                    }
                    window.location = data.session_url;
                })
                .catch((error) => {
                    this.classList.remove("loading");
                    document.body.style.cursor = 'auto';

                    alert("Le paiement pour cette vidéo n'est pas disponible.\nMerci de prévenir l'administrateur du site et de réessayer ultérieurement.");
                    console.error('Error:', error);
                });
            }
            else if (button.classList.contains('inactive')){
                window.location = "#/portal/signin";
            }
        });
    });
}
// CHECK IF IMAGE IS LOADED
function load(src) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', resolve);
        image.addEventListener('error', reject);
        image.src = src;
    });
}

/* =============== FETCHS =============== */
// Fetch friend posts
function fetch_friendPosts(site) {
    return fetch("https://" + new URL(site.url).hostname + "/ghost/api/content/posts/?include=tags&key=" + site.key + (site.key.includes("&") ? "" : "&limit=12&filter=tag:-blog"))
        .then(response => response.json())
        .then(data => {
            return data.posts;
        })
        .catch(function(e) {
            console.error("Ghost's " + site.name + " API error : " + e);
        });
}
// SUGGESTIONS
function fetch_suggestions(){

    return fetch(core+'/flows/trigger/a7aeb5f2-a891-4cf7-ba66-8dab987484c0?postid='+postID+'&member='+member+'&v='+Math.floor(Date.now() / (10 * 60000)), {
        credentials: 'include',
        cache: 'force-cache',
        method: 'GET'
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
                posts = data.posts.map(post => enhanceDOMarticle(createArticle(post)));
                return posts;
        })
        .catch(error => {
            console.error('Can not fetch suggestions:', error);
        });
}

// FETCH POSTS FROM LISTS (MyList, PlayerHistory, Rights)
async function fetch_list(){

    if (!member) {

        if (type == "MyPurchases"){
            document.location = "#/portal/signin";
            return false;
        }
        if ((type == "MyList" || type == "PlayerHistory") 
            && localStorage.getItem(type)
            && localStorage.getItem(type) !== "[]"){

            return fetch(core+'/flows/trigger/a7aeb5f2-a891-4cf7-ba66-8dab987484c0?ids='+JSON.parse(localStorage.getItem(type)).sort((a, b) => b.time - a.time).map(entry => entry.id).join(','), {
                credentials: 'include',
                method: 'GET'
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                        posts = data.posts.map(post => enhanceDOMarticle(createArticle(post,null,"feed")));
                        return posts;
                })
                .catch(error => {
                    //throw new Error(`Can not fetch posts:  ${error}`);
                    return [];
                });

        }
        else {
            return [];
        }

    }
    else {

        return fetch(core+'/flows/trigger/a7aeb5f2-a891-4cf7-ba66-8dab987484c0?member=true&list='+type, {
            credentials: 'include',
            method: 'GET'
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                /* ICI PETIT PROBLEME :
                Il faudrait depuis le flow séparer les 2 données MyList et PlayerHistory pour les update cote client au même moment */
                if (type == "PlayerHistory"){
                    playerHistory.replace(data.list);
                    document.dispatchEvent(new CustomEvent("memberPlayerHistoryReady", { detail: data.list }));
                }
                else if (type == "MyList"){
                    myList.replace(data.list);
                    document.dispatchEvent(new CustomEvent("memberMyListReady", { detail: data.list }));
                }

                if (data.rights){
                    memberData.rights = data.rights;
                    sessionStorage.setItem("memberRights", JSON.stringify(data.rights));
                    document.dispatchEvent(new CustomEvent("memberRightsReady", { detail: data }));
                }

                posts = data.posts.map(post => enhanceDOMarticle(createArticle(post,null,"feed")));
                return posts;
            })
            .catch(error => {
                console.error('Can not fetch posts:', error);
            });

    }
}
// FETCH VOD POST
function fetch_vodHTML(i = 1) {

    fetch(core+'/flows/trigger/bfa775e1-5255-4d10-82e1-5e0260e027d7', {
        credentials: 'include',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            postid: document.querySelector('article.single-post').dataset.id
        }),
    })
    .then(response => response.json())
    .then(data => {
        if (data.html !== undefined){
            document.querySelector('article.single-post .gh-content.gh-canvas').innerHTML = data.html;
            document.querySelector('article.single-post').classList.remove('noaccess');
                // On sélectionne les iframes 
                const vodiframes = document.querySelectorAll('.gh-content iframe');
                iframes = [];
                vodiframes.forEach(iframe => {
                    iframes.push(iframe.cloneNode(true));
                    iframe.remove();
                });
            bunseed_player("vod");
            document.querySelector('.lds-ring') ? document.querySelector('.lds-ring').remove() : null;
            if (payment == "success"){
                history.replaceState(null, '', location.pathname);
            }
        }
        else {
            // Faire une boucle pendant 6sec.
            if (payment == "success"){
                if (i < 6){
                    console.log("("+i+") Récupération de la vidéo échouée.");

                    // VISUAL LOADER
                    if (i == 1){
                        const ringLoader = document.createElement('div');
                        ringLoader.className = 'lds-ring';
                        for (let i = 0; i < 4; i++) {
                        const div = document.createElement('div');
                        ringLoader.appendChild(div);
                        }
                        const placeholder = document.querySelector('.single-post .post-media')
                        placeholder.prepend(ringLoader)
                    }

                    setTimeout(() => {
                        fetch_vodHTML(i + 1);
                      }, "1000");
                }
                else {
                    alert("Impossible de récupérer la vidéo.\nMerci de réessayer ultérieurement.\n\nSi le problème persiste, merci d'informer l'administrateur du site.");
                    moveCTA('show');
                    document.querySelector('.lds-ring') ? document.querySelector('.lds-ring').remove() : null;
                    console.log("("+i+") Récupération de la vidéo abandonnée.");
                }
            }
            else {
                bunseed_player();
                //moveCTA('show');
                document.querySelector('.lds-ring') ? document.querySelector('.lds-ring').remove() : null;
            }
            
        }
    })
    .catch((error) => {
        if (payment == "success"){
            alert("Impossible de récupérer la vidéo.\nMerci de réessayer ultérieurement et d'en informer l'administrateur du site.");
        }
        moveCTA('show');
        document.querySelector('.lds-ring') ? document.querySelector('.lds-ring').remove() : null;
        console.error('Error:', error);
    });
}
// FETCH LISTS (MyList, PlayerHistory, Rights)
function fetch_memberList(type){
    return fetch(core + "/flows/trigger/61d91c28-5c86-4eb3-9740-06953fbaf61e?type="+type, {
        credentials: 'include',
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        }
        }).then(response => response.json())
        .then(data => { 

            if (type == "all"){
                playerHistory.replace(data.playerhistory);
                document.dispatchEvent(new CustomEvent("memberPlayerHistoryReady", { detail: data.playerhistory }));

                myList.replace(data.mylist);
                document.dispatchEvent(new CustomEvent("memberMyListReady", { detail: data.mylist }));
                return true;
            }
            else if (type == "all+vod"){
                playerHistory.replace(data.playerhistory);
                document.dispatchEvent(new CustomEvent("memberPlayerHistoryReady", { detail: data.playerhistory }));

                myList.replace(data.mylist);
                document.dispatchEvent(new CustomEvent("memberMyListReady", { detail: data.mylist }));

                memberData.rights = data.rights;
                sessionStorage.setItem("memberRights", JSON.stringify(data.rights));
                document.dispatchEvent(new CustomEvent("memberRightsReady", { detail: data.rights }));
                return data.rights;
            }
            else if (type == "rights"){
                memberData.rights = data.rights;
                sessionStorage.setItem("memberRights", JSON.stringify(data.rights));
                document.dispatchEvent(new CustomEvent("memberRightsReady", { detail: data.rights }));
                return data.rights;
            }
            else if (type == "PlayerHistory"){
                playerHistory.replace(data.list);
                document.dispatchEvent(new CustomEvent("memberPlayerHistoryReady", { detail: data.list }));
                return data.list;
            }
            else if (type == "MyList"){
                myList.replace(data.list);
                document.dispatchEvent(new CustomEvent("memberMyListReady", { detail: data.list }));
                return data.list;
            }
            
        })
        .catch((error) => console.error('Error:', error));
}
const updateList = (type,list,online) => {

    if (member) {

        sessionStorage.setItem(type, list);
        
        //if (online && memberData){
        if (online){
        fetch(core + "/flows/trigger/8b7b972f-7335-438b-80d4-4377caf2eedf", {
            credentials: 'include',
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                type,
                list
                })
            })
            .catch((error) => console.error('Error:', error));
        }

    }
    else {

        localStorage.setItem(type, list);

    }
    

};
const throttledUpdateList = throttle(updateList, 5000);


/* ============== DOM =============== */

// Add infos to articles
function enhanceDOMarticle(article,target="all"){

      
    // Check if article is object
    if (!article || typeof article !== 'object') {
        throw new Error('Invalid article object');
    }

    // Properties
    let id = article.dataset.id || null;
    let type = null;
    let access = true;
    let date = null;
    let duration = article.dataset.duration || null;
    let json = article.dataset.json ? JSON.parse(decodeHtmlEntities(article.dataset.json)) : null;
    let playback = playerHistory.get(article.dataset.id) || null;
    let sells = [];
    let vodOnly = false;
    let vodLabel = null;
    let vodTitle = null;
    let storyboardOn = true;


    // Is article a single post ?
    if (article.classList.contains("single-post")){
        type = "single";
    }
    // Is article inside a tag page ?
    else if (article.closest('.post-feed')){
        type = "tag";
    }
    // Is article inside a carousel ?
    else {
        type = "carousel";
    }

    // Access ?
    if (article.classList.contains("noaccess")){
        access = false;
    }

    // Storyboard off
    if (article.classList.contains("tag-hash-storyboard-off")){
        storyboardOn = false;
    }



    // STORYBOARD
    if (storyboards && storyboardOn && target == "all" && type == "carousel" && json && json.storyboards){
        article.classList.add("storyboard");
        article.addEventListener('mouseover', () => {
            load(json.storyboards[0].storyboardPath).then(() => {

                let img = new Image();
                img.src = json.storyboards[0].storyboardPath;
                article.querySelector(".u-placeholder.square").style.setProperty('background-image', 'url('+img.src+')');

                if (img.src.includes("streamlike")) {
                    img.onload = () => {
                        if (img.width !== img.height * 100 / 56){
                            article.classList.add("storyboard2x");
                        }
                        article.classList.add("storyboard");
                    };
                }
                else {
                    article.classList.add("storyboard");
                }

            });
        });
            
    }

    // VOD find rights ?
    if ((target == "all" || target == "sells") && memberData && memberData.rights && memberData.rights.length) {
        const hasBuyRight = memberData.rights.some(function(right) {
          return right.postid.toString() === id && right.type === 'buy';
        });
      
        const validRentRights = memberData.rights.filter(function(right) {
          return right.postid.toString() === id && right.type === 'rent' && new Date() < new Date(right.date_expired);
        });
      
        const hasValidRentRight = validRentRights.length > 0;
      
        if (hasBuyRight) {
          vodLabel = 'Acheté ✅';
          vodTitle = 'Disponible à vie';
          access = true;
        } else if (hasValidRentRight) {
          const nearestExpiryDate = validRentRights.reduce(function(prev, current) {
            return (new Date(prev.date_expired) < new Date(current.date_expired)) ? prev : current;
          }).date_expired;
          vodLabel = 'Loué ✅';
          vodTitle = 'Location terminée ' + moment(new Date(nearestExpiryDate)).fromNow();
          access = true;
        } else {
          // Assuming there's no buy right or valid rent right, checking if there was any rent right.
          const hasAnyRentRight = memberData.rights.some(function(right) {
            return right.postid.toString() === id && right.type === 'rent';
          });
          if(hasAnyRentRight) {
            vodLabel = 'Location expirée';
          }
        }
    }

    // Get infos from Classes
    var classList = article.className.split(' ');

    for (let cls of classList) {

        // Date
        if (cls.startsWith("tag-hash-date-")) {
            date = transform_tagToDate(cls);
        }

        // Sells
        else if (   cls.startsWith("tag-hash-buy-")
            || cls.startsWith("tag-hash-rent-")
            || cls.startsWith("tag-hash-crowdfunding-")
            ) {
                sells.push(parseSellValues(cls));
        }

    }

    // Sort sells
    if (target == "all" && sells.length){
        sells.sort((a, b) => {
            // Trier par pwyw en true en premier
            if (a.pwyw && !b.pwyw) return -1;
            if (!a.pwyw && b.pwyw) return 1;
        
            // Trier par type : rent avant buy
            if (a.type === 'rent' && b.type !== 'rent') return -1;
            if (a.type !== 'rent' && b.type === 'rent') return 1;
        
            if (a.type === 'buy' && b.type !== 'buy') return -1;
            if (a.type !== 'buy' && b.type === 'buy') return 1;
        
            // Trier par serie en true après buy
            if (a.serie && !b.serie) return -1;
            if (!a.serie && b.serie) return 1;
        
            // Trier par amount croissant
            return a.amount - b.amount;
        });
    }  

    // VOD Only ?
    if (article.classList.contains("tag-hash-vod-only")){
        vodOnly = true;
    }


    // MANIPULATE DOM

        // SINGLE POST
        if (target == "all" && type == "single" && VOD && sells.length > 0){
        
            // CTA
            const buttonEl = article.querySelector(".gh-post-upgrade-cta .gh-btn");
            if (buttonEl) {
    
                let wrapper = document.createElement('div');
                wrapper.className = "gh-multi-btn";
                buttonEl.parentNode.insertBefore(wrapper, buttonEl);
                wrapper.appendChild(buttonEl);
    
                let textColor = window.getComputedStyle(buttonEl).color;
    
                const h2El = article.querySelector(".gh-post-upgrade-cta h2");
                h2El.textContent = "Disponible à la vente" + (vodOnly ? "" : " et " + h2El.textContent.substring(h2El.textContent.indexOf(" ") + 1));
    
                sells.forEach(e => {
                    let buttonHtml = `
                        <a class="gh-btn gh-portal-close gh-sell ${(member ? 'active' : 'inactive')}"
                            data-session="${e.tag.substring('tag-'.length)}"
                            style="color: ${textColor}"
                            title="${e.title}">
                            ${e.button}
                        </a>
                    `;
    
                    buttonEl.insertAdjacentHTML('beforebegin', buttonHtml);
    
                    if (vodOnly) {
                        buttonEl.style.display = 'none';
                    }
                });
    
            }
    
        }
    
        // CAROUSEL & FEED POSTS
        else {
    
            // DURATION
            if (target == "all" && duration){
    
                const durationPlaceholder = article.querySelector(".post-image-link");
                if (durationPlaceholder) {
    
                    // Create duration element
                    const durationEl = `<span class="post-media-duration"> ${simplifyDuration(duration)} </span>`;
    
                    // Place in DOM
                    durationPlaceholder.insertAdjacentHTML('afterbegin', durationEl);
    
                }
    
            }
    
            // ACCESS
            //if (target == "all" && access){
            if (access){
                article.classList.remove('noaccess');
            }

            // PLAYBACK POSITION
            if ((target == "all" || target == "playback") && playback){ // + ASYNC
    
                const playbackPlaceholder = article.querySelector('.post-media .u-placeholder a');
                if (playbackPlaceholder){

                    playbackPlaceholder.querySelector(".post-media-progress") ? playbackPlaceholder.querySelector(".post-media-progress").remove() : null;
    
                    // Create progress element
                    const progressEl = `<div class="post-media-progress" style="width:${playback.position/playback.duration*100}%" title="${Math.round(playback.position/playback.duration*100)}%"></div>`;
    
                    // Place in DOM
                    playbackPlaceholder.insertAdjacentHTML('afterbegin', progressEl);
    
                    // Video full watched
                    if (playback.duration - playback.position < 10) {
                        article.classList.add('viewed');
                    }
                }
    
            }
    
            // SELLS
            if ((target == "all" || target == "sells") && sells.length){
    
                const accessEl = article.querySelector(".post-media-access");
                if (accessEl !== null) {
    
                    if (vodLabel && vodTitle){
                        accessEl.innerHTML = vodLabel;
                        accessEl.setAttribute('title', vodTitle);
                    }
                    else if (!access) {
                        let label_title = '';
                    
                        if (sells.length > 1) {
                            label_title = "- " + sells.map(item => item.title).join("\n- ");
                        } else {
                            label_title = sells[0].title;
                        }
                    
                        accessEl.innerHTML = vodLabel || sells[0].label;
                        accessEl.setAttribute('title', label_title);
                    }
                }
    
            }
    
        }
    
        // FOR ALL POSTS
    
            // DATE
            const dateEl = article.querySelector("time");
            if (dateEl){
    
                // If futur date
                if (date){
                    dateEl.setAttribute("datetime", date)
                    dateEl.innerHTML = moment(date, "YYYY-MM-DD hh:mm").format("Do MMM YYYY");
                }
    
                // Transform Date with Time Ago & Labels
                doTimeAgo(dateEl, type);
    
            }
    
    return article;

}
function doTimeAgo(element,datatype){

    const dateStr = element.getAttribute('datetime');
    const now = moment();
    const date = moment(dateStr);
    const secondsDiff = now.diff(date, 'seconds');

    if (datatype == "carousel") {
        element.innerHTML = moment(dateStr, "YYYY-MM-DD hh:mm").fromNow();
    }
    
    if (secondsDiff <= - 7 * 24 * 60 * 60) { // in more than 7 days
        Array.from(element.getElementsByClassName('new')).forEach(el => el.remove());
        element.insertAdjacentHTML("afterbegin", "<span class='new'>Prochainement</span>");
    }
    else if (secondsDiff <= - 2 * 60 * 60) { // from 7 days to 2 hours
        Array.from(element.getElementsByClassName('new')).forEach(el => el.remove());
        element.insertAdjacentHTML("afterbegin", "<span class='new'>Bientôt</span>");
    }
    else if (secondsDiff <= - 5 * 60) { // from 2 hours to 5 minutes
        Array.from(element.getElementsByClassName('new')).forEach(el => el.remove());
        element.insertAdjacentHTML("afterbegin", "<span class='new soon'>Très bientôt</span>");
    }
    else if (secondsDiff <= 0) { // from 5 minutes to now
        Array.from(element.getElementsByClassName('new')).forEach(el => el.remove());
        element.insertAdjacentHTML("afterbegin", "<span class='new about-to-start'>Ça va commencer</span>");
    }
    else if (secondsDiff < 7 * 24 * 60 * 60) {
        Array.from(element.getElementsByClassName('new')).forEach(el => el.remove());
        element.insertAdjacentHTML("afterbegin", "<span class='new'>Nouveau</span>");
    }

    // Refresh if recent or soon
    if (Math.abs(secondsDiff) < 20 * 60) { // below 20 minutes, refresh every 4 seconds
        setTimeout(() => { doTimeAgo(element) }, 4 * 1000);
    }
    else if (Math.abs(secondsDiff) < 2 * 60 * 60) { // below 2 hours, refresh every minute
        setTimeout(() => { doTimeAgo(element) }, 60 * 1000);
    }

}
// Create article from post json (ghost) and site info (friends)
function createArticle(post,site,type = "carousel") {

    // Crée l'élément <article>
    const article = document.createElement('article');
    article.classList.add('post');
    if (!post.feature_image) {
        article.classList.add('no-image');
    }
    if (!post.access) {
        article.classList.add('noaccess');
    }
    post.tags.forEach(tag => {
          article.classList.add(`tag-${tag.slug}`);
    });

    article.setAttribute('data-id', post.id);
    article.setAttribute('data-duration', post.og_title || '');
    article.setAttribute('data-json', post.twitter_description || '');
    article.setAttribute('tabindex', '0');

    let postAccess = '';
    if (post.visibility !== 'public') {
        if (post.visibility == 'members') {
            postAccess = (post.access ? 'Abonné⸱e ✅' : 'Abonné⸱e');
        } else {
            postAccess = (post.access ? 'Membre ✅' : 'Membre');
        }
    }

    let articleContent = ``;

    // Article for Carousel
    if (type == "carousel"){

    // Contenu de l'article
    articleContent = `
        <figure class="post-media">
            <div class="u-placeholder square">
                <a class="post-image-link" href="${post.url}" title="${post.title}"${site ? ` target="_blank"` : ``}>
                `; if (site || postAccess){ articleContent += `<span class="post-media-access"`; if (site){ articleContent += ` title="&#x27A1; ${site.name}"> `; } else { articleContent += `>`; } articleContent += `${postAccess}</span>`; } articleContent += `
                    <img
                        class="post-image u-object-fit"`;
                    if (post.img_s){ articleContent += `
                        srcset="${post.img_s} 400w, ${post.img_m} 750w, ${post.img_l} 960w, ${post.img_xl} 1140w"
                        src="${post.img_s}"`; } 
                    else if (post.feature_image){ articleContent += `
                        src="${post.feature_image}"`; } 
                    else { articleContent += `
                        src="https://via.placeholder.com/1024x576.png?text=Vignette+absente"`; } articleContent += `
                        alt="${post.feature_image_alt || post.title}"
                        loading="lazy"
                    >
                </a>
            </div>
        </figure>

        <header class="post-header">
            <h2 class="post-title">
                `; if (site){ articleContent += `<a href="${site.url}" target="_blank" title="${site.name}" tabindex="-1"><img class="avatar" src="${site.profile_image || "https://via.placeholder.com/60x60.png?text=:-)"}"></a>`; }
                articleContent += `
                <a class="post-title-link" href="${post.url}" title="${post.title}"${site ? ` target="_blank"` : ``}>${post.title}</a>
            </h2>
            <div class="post-meta">
                <span class="post-meta-item post-meta-date">
                    <time datetime="${post.published_at}">${formatDate(post.published_at)}</time>
                </span>
                `; if (site){ articleContent += `<span class="author-link"><a href="${site.url}" target="_blank" tabindex="-1">${site.name}</a></span>`; }
                articleContent += `
            </div>
        </header>
    `;

    }

    // Article for Feeds
    else {

    articleContent = `    
        <figure class="post-media gh-canvas">
            <div class="u-placeholder square kg-width-wide">
                <a class="post-image-link" href="${post.url}">
                    `; if (postAccess){ articleContent += `<span class="post-media-access">${postAccess}</span>`; }
                    if (post.feature_image){ articleContent += `
                    <img
                        class="post-image u-object-fit"
                        srcset="${post.img_s} 400w, ${post.img_m} 750w, ${post.img_l} 960w, ${post.img_xl} 1140w, ${post.img_xxl} 1920w"
                        sizes="(min-width: 960px) 960px, 92vw"
                        src="${post.img_l}"
                        alt="${post.title}"
                        loading="lazy"
                    >`;
                    } else { articleContent += `
                    <img
                        class="post-image u-object-fit"
                        sizes="(min-width: 960px) 960px, 92vw"
                        src="https://via.placeholder.com/1024x576.png?text=Vignette+absente"
                        alt="${post.title}"
                        loading="lazy"
                    >`;
                    } articleContent += `
                </a>
            </div>
        </figure>
    
        <div class="gh-canvas">
            <header class="post-header">
                <h2 class="post-title">
                    <a class="post-title-link" href="${post.url}">${post.title}</a>
                </h2>
                <div class="post-meta">
                    <span class="post-meta-item post-meta-date">
                        <time datetime="${post.published_at}">${formatDate(post.published_at)}</time>
                    </span>
                    `; if (post.primary_tag){ articleContent += `
                        <span class="post-meta-item post-meta-tags"><a class="post-tag post-tag-${post.primary_tag.slug}" href="${post.primary_tag.url}" title="${post.primary_tag.name}">${post.primary_tag.name}</a></span>
                    `; } articleContent += `
                </div>
            </header>
    
            `; if (decodeURI(post.excerpt)){ articleContent += `
                <div class="post-excerpt">
                    ${decodeURI(post.excerpt)}
                </div>
            `; } articleContent += `
        </div>
    
    </article>`;

    }

    // Ajoute le contenu de l'article à l'élément <article>
    article.innerHTML = articleContent;

    return enhanceDOMarticle(article);
}

// ADD POSTS TO CAROUSEL // A REFAIRE ?
function addPoststoCarouel(carousel, posts) {

    // PUSH IN CAROUSEL
    if (carousel.classList.contains('owl-loaded')) {
        posts.forEach(function(item) {
            $(carousel).trigger('add.owl.carousel', [item])
                .trigger('refresh.owl.carousel');
        });
    }
    // PUSH
    else {
        posts.forEach(function(item) {
            $(carousel).append(item);
        });
        constructShowmoreArticles($(carousel));
    }

}
// ADD POSTS TO FEED
function addPoststoFeed(articles) {

    articles.forEach(function(article) {

        if (type == "MyList" || type == "PlayerHistory"){

            var button = document.createElement('div');
            button.classList.add('remove-button');
            button.setAttribute('title', 'Retirer de ma '+ (type == "MyList" ? "liste" : "historique"));
            button.innerHTML = '×';

            var placeholder = article.querySelector('.post-media .u-placeholder');
            if (placeholder) {
            placeholder.classList.add('is-remove-button');
            placeholder.appendChild(button);
            }
        }
        else if (type == "MyPurchases"){

            const filteredRights = memberData.rights.filter(ri => ri.postid.toString() === article.dataset.id);
            const invoices = filteredRights.map(right => {
                const dateFormatted = new Date(right.date_created).toLocaleDateString();
                const linkText = right.type === 'buy' ? `Facture d'achat (${dateFormatted})` : `Facture de location (${dateFormatted})`;
                const target = right.stripe_invoice_url ? ` target="_blank"` : ` onclick="alert('Facture absente. Merci de contacter l\\'administration du site.')"`;
                return `<a href="${right.stripe_invoice_url || "javascript:void()"}"${target}>${linkText}</a>`;
            }).join('');
    
            var invoiceLinks = document.createElement('div');
            invoiceLinks.classList.add('invoices');
            invoiceLinks.innerHTML = invoices;
    
            article.querySelector('.post-image-link').prepend(invoiceLinks); 

        }

        $(".post-feed").append(article);

    });

    if (articles.length > 0){

        document.querySelectorAll('.remove-button').forEach(function(button) {
            button.addEventListener('click', function() {
                if (confirm("Merci de confirmer la suppression de cette vidéo de votre "+ (type == "MyList" ? "liste." : "historique."))){
                    var post = this.closest('article');
                    if (type == "MyList"){
                        myList.delete(post.dataset.id);
                    }
                    else if (type == "PlayerHistory"){
                        playerHistory.delete(post.dataset.id);
                    }
                    post.remove();
                }
            });
        });

        if (type == "PlayerHistory"){
            var buttonAll = document.createElement('a');
            buttonAll.setAttribute('href', '#');
            buttonAll.innerHTML = 'Effacer tout mon historique.';
            buttonAll.addEventListener('click', function(e) {
            e.preventDefault();
            if (confirm("Merci de confirmer la suppression de tout votre historique.")){
                playerHistory.deleteAll();
                document.querySelectorAll('.post-feed article').forEach(function(node) {
                    node.remove();
                });
                document.querySelector('.term-description').innerHTML = 'Votre historique est vide.';
            }
            });
            document.querySelector('.term-description').append(buttonAll);
        }



    }
    else {
        document.querySelector('.term-description').append('Aucune vidéo présente dans votre '+ (type == "MyList" ? "liste" : "historique")+' pour le moment.');
    }

}

// Display, move, hide CTA
function moveCTA(action){

    const placeholder = document.querySelector('.single-post .post-media')
    const upgradeBlock = document.querySelector('aside.gh-post-upgrade-cta')
  
    if (upgradeBlock){
      if (action == 'show' && upgradeBlock.parentNode && upgradeBlock.parentNode !== placeholder){
        placeholder.classList.add('calltoaction')
        placeholder.prepend(upgradeBlock)
      }
      else if (action == 'hide' && upgradeBlock.parentNode && upgradeBlock.parentNode == placeholder){
        placeholder.classList.remove('calltoaction')
        document.querySelector('.gh-content').appendChild(upgradeBlock)
      }
      /*else {
        placeholder.classList.remove('calltoaction')
        upgradeBlock ? upgradeBlock.remove() : '';
      }*/
    }
}
// Resize Chat (JQUERY TO CONVERT)
function resizeChat(){
    if ($('iframe.chat').length){
        if ($('.single-post .post-media.post-main').css('display') != 'block'){
            $('iframe.chat').height('100%');
        }
        else {
            $('iframe.chat').height(Math.floor($(window).height() - $('.post-media.post-main .player').height() - $('#gh-head').height()));
        }
    }
}
// Remove DOM not access for member
function removeUnaccessDom(){
    const memberTypes = ['free', 'member', 'memberpaid'];

    let selectors = [];

    memberTypes.forEach((memberType) => {
        const otherTypes = memberTypes.filter(type => type !== memberType);
        
        const notClasses =  [
            `showto-${memberType}`,
            `block-showto-${memberType}`,
            `flex-showto-${memberType}`
        ];
        
        const classesToHide = otherTypes.map(type => [
            `showto-${type}`,
            `block-showto-${type}`,
            `flex-showto-${type}`
        ]).flat();
        
        classesToHide.forEach(classToHide => {
            const notSelectors = notClasses.map(notClass => `:not(.${notClass})`).join('');
            selectors.push(`.useris-${memberType} .${classToHide}${notSelectors}`);
        });
    });

    let elements = document.querySelectorAll(selectors.join(', '));
    elements.forEach((element) => {
        element.remove();
    });
}

function postActions_addData(type = "all") {

    // DON WITH STRIPE
    if (type == "member"){
        document.querySelectorAll('#actions .give a[href*="stripe.com"]').forEach(function(link) {
            if (memberData.type !== "error") {
                const href = link.getAttribute('href');
                link.setAttribute('href', href + "?prefilled_email=" + encodeURIComponent(memberData.email));
            }
        });
    }

    // COMMENT WITH TALLY
    document.querySelectorAll('a[href*="tally-open"]').forEach(function(link) {
        const data = (type == "member" && memberData ? "email="+encodeURIComponent(memberData.email)+"&name="+encodeURIComponent(memberData.name)+"&" : "") + "origin=" + encodeURIComponent(location.href.split(location.host)[1]);
        let src = link.getAttribute('href'), href, urlParams, tallyID;

        if (src.includes("#")) {
            href = src.split("#");

            if (src.includes("tally.so") && !src.includes("tally.so/r/")) {
                urlParams = new URLSearchParams(href[1]);
                tallyID = urlParams.get('tally-open');
                href[0] = "https://tally.so/r/" + tallyID;
            }
            
            link.setAttribute(
                'href',
                (href[0].includes("tally.so/r/")
                    ? href[0] + "?" + data + "#" + href[1] + "&" + data
                    : href[0] + "#" + href[1] + "&" + data
                )
            );
        } else {
            link.setAttribute('href', src + "?" + data);
        }
    });

    // TALLY IFRAME
    document.querySelectorAll('iframe[src*="tally.so"]').forEach(function(iframe) {
        const data = (type == "member" && memberData !== "error" ? "email="+encodeURIComponent(memberData.email)+"&name="+encodeURIComponent(memberData.name)+"&" : "") + "origin=" + encodeURIComponent(location.href.split(location.host)[1]);
        let src = iframe.getAttribute('src');

        iframe.setAttribute('src', src + "&" + data);
    });

}

function store_scrollPosition(){
    const storeScroll = () => {
    document.documentElement.dataset.scroll = window.scrollY;
    }
    document.addEventListener('scroll', debounce(storeScroll), { passive: true });
    storeScroll();
}

/* DARK MODE */
const btn = document.querySelector(".nightshift-toggle");
const htmlEl = document.querySelector("html");
if (btn) {
    const prefersColorScheme = window.matchMedia("(prefers-color-scheme: dark)");
    let preferMode = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    const chosenMode = localStorage.getItem("theme");

    // Récupérer le thème actuel et l'appliquer
    let currentTheme = chosenMode ? chosenMode : preferMode;
    toggleTheme(currentTheme == "dark" ? "light" : "dark");

    btn.addEventListener("click", function () {
        currentTheme = toggleTheme(currentTheme);
    });

    // Fonction pour basculer le thème
    function toggleTheme(current) {
        if (current === "dark") {
            htmlEl.classList.remove("dark-mode");
            btn.classList.remove("on");
            if (preferMode == "light"){
                localStorage.removeItem("theme");
            } else {
                localStorage.setItem("theme", "light");
                htmlEl.classList.add("light-mode");
            }
            return "light";
        } else {
            htmlEl.classList.remove("light-mode");
            btn.classList.add("on");
            if (preferMode == "dark"){
                localStorage.removeItem("theme");
            } else {
                localStorage.setItem("theme", "dark");
                htmlEl.classList.add("dark-mode");
            }
            return "dark";
        }
    }
    prefersColorScheme.addEventListener("change", function(){
        preferMode = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
        currentTheme = toggleTheme(preferMode == "dark" ? "light" : "dark")
    });
}

/* ============ CAROUSELS ============= (JQUERY) */ 
function constructShowmoreArticles(carousel,articlesByPage = 4){

    var totalArticles = carousel.find('article').length;

    if (totalArticles > articlesByPage){

        var carouselID = slugify(carousel.parent().find("h5").text()) + carousel.find('article').first().data('id');
        var numPage = sessionStorage['numPageCarousel'+carouselID] ? Number(sessionStorage['numPageCarousel'+carouselID]) : 0;
        
        var debut = numPage * articlesByPage;
        var fin = debut + articlesByPage;

        carousel.find('article').slice(debut, fin).show();
        carousel.find('article').slice(fin, totalArticles).hide();

        if (!carousel.parent().find('button.showmore').length){
            if (fin >= totalArticles) {
                carousel.after($(`<button tabindex="0">Replier <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
              </svg></button>`).addClass('showmore').click(function(){buttonShowmoreArticles(this,articlesByPage)}));
            } else {
                carousel.after($(`<button tabindex="0">Voir plus <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
              </svg></button>`).addClass('showmore').addClass('more').click(function(){buttonShowmoreArticles(this,articlesByPage)}));
            }
        }
    }
}
function buttonShowmoreArticles(button,articlesByPage = 4){
    if ($(button).hasClass('more')){
        ShowmoreArticles($(button).prev('.carousel'),articlesByPage);
    }
    else {
        ShowlessArticles($(button).prev('.carousel'),articlesByPage);
    }
}
function ShowmoreArticles(carousel,articlesByPage = 4){
    var carouselID = slugify(carousel.parent().find("h5").text()) + carousel.find('article').first().data('id');

    sessionStorage['numPageCarousel'+carouselID] = Number(sessionStorage['numPageCarousel'+carouselID] ? sessionStorage['numPageCarousel'+carouselID] : 0) + 1;
    var numPage = Number(sessionStorage['numPageCarousel'+carouselID]);

    var totalArticles = carousel.find('article').length;
    var debut = numPage * articlesByPage;
    var fin = debut + articlesByPage;

    var buttonShowMore = carousel.parent().find('button.showmore');

    if (numPage == 0){
        carousel.find('article').slice(fin, totalArticles).hide();
    } else {
        carousel.find('article').slice(debut, fin).fadeIn(200);
    }

    if (fin >= totalArticles) {
        buttonShowMore.removeClass("more").html(`Replier <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
        <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
      </svg>`);
    }
}
function ShowlessArticles(carousel,articlesByPage = 4){
    var carouselID = slugify(carousel.parent().find("h5").text()) + carousel.find('article').first().data('id');
    sessionStorage['numPageCarousel'+carouselID] = 0;
    var numPage = 0;
    
    var totalArticles = carousel.find('article').length;
    var debut = numPage * articlesByPage;
    var fin = debut + articlesByPage;

    var buttonShowMore = carousel.parent().find('button.showmore');

    carousel.find('article').slice(fin, totalArticles).hide();
    $([document.documentElement, document.body]).animate({
        scrollTop: carousel.find('article').eq(articlesByPage - 2).offset().top
    }, 0);

    buttonShowMore.addClass("more").html(`Voir plus <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
  </svg>`);
}
function destroyShowmoreArticles(carousel){
    carousel.css('visibility', 'visible');
    carousel.find('article').show();
    carousel.parent().find('button.showmore').remove();
}
function carousel() {

    var imageHeight, nav;

    function moveNav(target) {
        imageHeight = target.find('.post-image').height();
        nav = target.find('.owl-prev, .owl-next');
        nav.css({
            top: imageHeight / 2 + 'px',
            opacity: 1,
        });
    }

    $('.carousel').each(function(){

        const carousel = $(this);
        settings = carousel.data('carousel') ? carousel.data('carousel') : undefined;

        if (settings == undefined){
            if (carousel.hasClass('playlist') && !carousel.hasClass('shorts')){
                settings = {
                    minWidth : null,
                    responsive : {
                        0: {
                            items: 2,
                            slideBy: 2,
                            nav: true,
                        },
                        768: {
                            items: 3,
                            slideBy: 3,
                        },
                        992: {
                            items: 4,
                            slideBy: 4,
                        },
                    }
                };
            }
            else if (carousel.hasClass('authors') || carousel.hasClass('shorts')){
                settings = {
                    minWidth : null,
                    responsive : {
                        0: {
                            items: 3,
                            slideBy: 3,
                            nav: true,
                            margin: 0,
                        },
                        768: {
                            items: 4,
                            slideBy: 4,
                            margin: 12,
                        },
                        992: {
                            items: 5,
                            slideBy: 5,
                        }
                    }
                };
            }
            else {
                settings = {
                    minWidth : 768,
                    responsive : {
                        0: {
                            items: 1,
                            slideBy: 1,
                            nav: true,
                        },
                        768: {
                            items: 3,
                            slideBy: 3,
                        },
                        992: {
                            items: 4,
                            slideBy: 4,
                        }
                    }
                };
            }
        }

        if (settings.minWidth !== null){

            if (window.matchMedia("(min-width: "+settings.minWidth+"px)").matches){
                makeCarousel(carousel,settings);
            } else {
                constructShowmoreArticles(carousel,getArticlesByPage(settings.responsive));
            }
            
        } else {
            makeCarousel(carousel,settings);
        }

    });

    function makeCarousel(carousel,settings){

        carousel.owlCarousel({
            dots: false,
            margin: 12,
            nav: true,
            smartSpeed: 60,
            lazyLoad: true,
            navText: [
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="22" height="22" fill="currentColor"><path d="M20.547 22.107l-6.107-6.107 6.107-6.12-1.88-1.88-8 8 8 8 1.88-1.893z"></path></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="22" height="22" fill="currentColor"><path d="M11.453 22.107l6.107-6.107-6.107-6.12 1.88-1.88 8 8-8 8-1.88-1.893z"></path></svg>',
            ],
            onInitialized: function() {
                carousel.css('visibility', 'visible'); // c'était là pour les authors ?
                moveNav(carousel);
                if (settings.minWidth != null){
                    destroyShowmoreArticles(carousel,getArticlesByPage(settings.responsive));
                }
            },
            onResized: function() {
                moveNav(carousel);
                if (settings.minWidth !== null){ if (window.matchMedia("(max-width: "+settings.minWidth+"px)").matches) {
                    carousel.trigger('destroy.owl.carousel');
                    constructShowmoreArticles(carousel,getArticlesByPage(settings.responsive));
                }}
            },
            onRefreshed: function() {
                moveNav(carousel);
            },
            responsive: settings.responsive,
        });
    }

    function getArticlesByPage(responsive){
        let keys = Object.keys(settings.responsive);
        let maxKey = Math.max(...keys);
        let maxItems = settings.responsive[maxKey].items;
        return maxItems;
    }

}


/* =============== PLAYER ================ */
// On fullscreen button click
function fullscreen() {
    document.querySelectorAll('.single-post .post-media.post-main .fullscreen-button').forEach(button => {
        button.addEventListener('click', function() {
            if (!document.fullscreenElement) {
                document.querySelector('.single-post .post-media.post-main').requestFullscreen();
            } else {
                document.exitFullscreen();
            }
        });
    });

    document.querySelectorAll('.gh-post-upgrade-cta a').forEach(cta => {
        cta.addEventListener('click', function() {
            if (window.fullScreen || (window.innerWidth === screen.width && window.innerHeight === screen.height)) {
                document.exitFullscreen();
            }
        });
    });
}
function bunseed_player(from){
    const videoHosts = ['youtube', 'peertube', 'streamlike', 'vimeo']
    const chatHosts = ['livechat', 'webchat', 'sli.do']
    
    // Si plusieurs iframes, on supprime la première qui est un teaser
    if (iframes.length > 1 && !chatHosts.some(host => iframes[1].src.includes(host))) {
      if (videoHosts.some(host => iframes[0].src.includes(host))) {
        iframes.splice(0,1);
      }
    }

    // Si y'a une iframe
    if (iframes.length > 0) {
    
      const postMedia = document.querySelector('.post-media.post-main')
    
      // Si y'a un chat
      if (iframes[1] && chatHosts.some(host => iframes[1].src.includes(host))) {
        var iframe = iframes[1]
        document.querySelector("body").classList.add("videaste_chat")
        iframe.classList.add("chat")
        iframe.style.height = "100%"
        postMedia.querySelector(".post-image").classList.add("player")
        postMedia.appendChild(iframe)
      }
    
      // Si y'a un player
      if (videoHosts.some(host => iframes[0].src.includes(host))) {
        var iframe = iframes[0];
        document.querySelector("body").classList.add("videaste_player")
        // iframe.style.height = "100%"
        iframe.classList.add("player")
        iframe.setAttribute("id","player")
        
        // activer API
        var url = iframe.getAttribute('src').split('#')[0]
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'api=1&enablejsapi=1&events=1&autoplay=1'
        // Pour YouTube
        url += '&origin='+site
        
        iframe.setAttribute('src', url)
        // autoriser autoplay
        iframe.setAttribute('allow', 'autoplay')
        iframe.setAttribute('allow-top-navigation', '')
        iframe.getAttribute('sandbox')?iframe.setAttribute('sandbox', iframe.getAttribute('sandbox')+' allow-top-navigation'):''
        
    
        // MOVE PLAYER TO HEAD
        postMedia.querySelector(".post-image").remove();
        postMedia.prepend(iframe)
    
        iframe.style.position = "relative";
        if (iframe.getAttribute("height") !== undefined && iframe.getAttribute("width") !== undefined){
            iframe.style.height = (iframe.offsetWidth * iframe.getAttribute("height") / iframe.getAttribute("width"))+"px";
        }
        else {
            iframe.style.height = (iframe.offsetWidth * .5625)+"px";
        }
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", function() {
                playerReframe(iframe)
            })
        } else {
            playerReframe(iframe)
        }
        
      }
    
    }
    else {
        moveCTA("show");
    }
}
// REFRAME PLAYER + ADD FULLSCREEN BUTTON 
function playerReframe(iframe){

    if (typeof reframe === "function"){
        reframe(iframe)
        loadPlaylist()
    }
    else {
        setTimeout(function() { playerReframe(iframe) }, 100);
    }
    
    const fullscreenButton = document.createElement('div')
        fullscreenButton.classList.add('fullscreen-button')
        iframe.parentNode.appendChild(fullscreenButton)
        fullscreen() 

    // RUN API
    run(iframe)
    
}
async function run(videoiFrame) {

    // YOUTUBE
    if (videoiFrame.src.includes('youtube.com')){
  
      var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  
    }
  
    // VIMEO
    else if (videoiFrame.src.includes('vimeo.com')){
  
      loadScript("https://player.vimeo.com/api/player.js", function(){
          var player = new Vimeo.Player(videoiFrame);
          
        if (urlParams.get('t') || urlParams.get('start')){
            player.setCurrentTime((urlParams.get('t') || urlParams.get('start')).replace("s", ""));
        } else {
          var state = playerHistory.get(postID)
          if (state){
              if (state.duration - state.position > 10){ // Si c'est la fin de la video, lire depuis le début
                  player.setCurrentTime(state.position - 5) // 5 sec en arriere
              }
          }
        }
  
          // timecodes cliquables
          useTimecodes("vimeo",player);
  
          player.on('timeupdate', function(data) {
              player_playing(data.seconds,data.duration)
          });
  
      });
  
    }
  
    // STREAMLIKE
    else if (videoiFrame.src.includes('streamlike.com')){
  
          var duration = false;
          var urlObjet = new URL(videoiFrame.src);
          var med_id = urlObjet.searchParams.get('med_id');
          fetch('https://cdn.streamlike.com/ws/media?media_id=' + med_id + '&f=json')
              .then(response => response.json())
              .then(data => {
                  duration = data.media.metadata.global.duration;
              })
              .catch((error) => console.error('Erreur:', error));
  
        if (urlParams.get('t') || urlParams.get('start')){
            videoiFrame.addEventListener('load', function() {
                videoiFrame.contentWindow.postMessage('["seek",'+ (urlParams.get('t') || urlParams.get('start')).replace("s", "") +']', "*")
            }, false);
        } else {
          var state = playerHistory.get(postID)
          if (state){
              if (state.duration - state.position > 10){ // Si c'est la fin de la video, lire depuis le début
                  videoiFrame.addEventListener('load', function() {
                      videoiFrame.contentWindow.postMessage('["seek",'+ (state.position - 5) +']', "*")
                  }, false);
  
              }
          }
        }
  
          // timecodes cliquables
          useTimecodes("streamlike",videoiFrame);
          
          window.addEventListener("message", function(e){
              if (typeof e.data === 'string' || e.data instanceof String){
                  sl = JSON.parse(e.data)
                  if (sl[0] == "sl-progress" && duration !== false){
                      player_playing(sl[1],duration)
                  }
              }
          });
  
    }
  
    // PEERTUBE
    else {
  
      const PeerTubePlayer = window['PeerTubePlayer']
      const player = new PeerTubePlayer(videoiFrame)
  
      await player.ready
  
      if (urlParams.get('t') || urlParams.get('start')){
            await player.seek((urlParams.get('t') || urlParams.get('start')).replace("s", ""));
      } else {
        var state = playerHistory.get(postID)
        if (state){
            if (state.duration - state.position > 10){ // Si c'est la fin de la video, lire depuis le début
                await player.seek(state.position - 5) // 5 sec en arriere
            }
        }
      }
  
      // timecodes cliquables
      useTimecodes("peertube",player);
      
      await player.addEventListener("playbackStatusUpdate", function(e){
  
          if (e.playbackState == "playing"){
              player_playing(e.position,e.duration)
          }
  
      })
  
    }
    
}
window.onYouTubeIframeAPIReady = function() {
    if (document.querySelector("#player").src.includes('youtube.com')){
        player = new YT.Player('player', {
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });
    }
}
// The API will call this function when the video player is ready.
function onPlayerReady(event) {

    if (urlParams.get('t') || urlParams.get('start')){
            player.seekTo((urlParams.get('t') || urlParams.get('start')).replace("s", ""), true);
            player.playVideo();
    } else {
        var state = playerHistory.get(postID)
        if (state){
            if (state.duration - state.position > 10){ // Si c'est la fin de la video, lire depuis le début
            player.seekTo(state.position - 5, true);
            player.playVideo();
            }
        }
    }

    // timecodes cliquables
    useTimecodes("youtube",player);
  
}
// The API calls this function when the player's state changes.
function onPlayerStateChange(event) {

    player_playing(player.getCurrentTime(),player.getDuration())

    if (event.data === YT.PlayerState.PLAYING) {
          timer = setInterval(function() {
            player_playing(player.getCurrentTime(),player.getDuration())
          }, 1000);
        }
    else {
        if (typeof timer !== 'undefined') {
            clearInterval(timer);
        }
    }

}
function player_playing(position,duration){

  if (duration > 20 && position > 5
      && !document.querySelector('.single-post').classList.contains('noaccess')){

            // Enregistrer position de lecture
            var state = {'id':postID, 'position': position, 'duration': duration, 'time': Date.now()}
            playerHistory.add(state);

              // Next video bouton
            if (duration - position < 16){
                document.querySelector('.single-post .post-media.post-main').classList.add("display-nextbutton")
            } else {
                document.querySelector('.single-post .post-media.post-main').classList.remove("display-nextbutton")
            }
            if (duration - position < 1 && localStorage['autoplay'] != 'false'){
                if (document.querySelector(".nextbutton") !== null){
                    window.location = document.querySelector(".nextbutton a.post-image-link").getAttribute("href")
                }
            }
        }
  // Afficher call to action si fin de vidéo teaser et pas accès
  else if (duration > 10 && document.querySelector('.single-post').classList.contains('noaccess')){

    if (duration - position < 1) {
        moveCTA('show')
    } else {
        moveCTA('hide')
    }

  }

}
function loadScript(url, callback){
        var script = document.createElement("script")
        script.type = "text/javascript";
    
        if (script.readyState){  //IE
            script.onreadystatechange = function(){
                if (script.readyState === "loaded" || script.readyState === "complete"){
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {  //Others
            script.onload = function(){
                callback();
            };
        }
    
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
}
function useTimecodes(source,player){

    function timecodeToSeconds(timecode) {
        var parts = timecode.split(':').map(Number);
        var seconds = 0;

        if (parts.length === 3) {
            seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
        } else if (parts.length === 2) {
            seconds = parts[0] * 60 + parts[1];
        }

        return seconds;
    }

    // Créer les liens cliquables s'il y a des timecodes dans des paragraphes
    document.querySelectorAll('.gh-content p').forEach(function(p) {
        p.innerHTML = p.innerHTML.replace(
            /\b((?:\d{1,2}:)?\d{1,2}:\d{2})\b/g,
            function(match) {
                var seconds = timecodeToSeconds(match);
                return `<a href="?t=${seconds}" class="gototimecode" data-seconds="${seconds}">${match}</a>`;
            }
        );
    });

    // Rendre les liens actifs suivant le player
    document.addEventListener('click', function(e) {
        if (e.target && e.target.matches('.gototimecode')) {
            e.preventDefault();
            var seconds = e.target.getAttribute('data-seconds');
            if (seconds && player) {

                if (source == "youtube"){
                    player.seekTo(parseFloat(seconds));
                    player.playVideo();
                }
                else if (source == "peertube"){
                    player.seek(parseFloat(seconds));
                    player.play();
                }
                else if (source == "vimeo"){
                    player.setCurrentTime(parseFloat(seconds));
                    player.play();
                }
                else if (source == "streamlike"){
                    player.contentWindow.postMessage('["seek",'+ parseFloat(seconds) +']', "*");
                    player.contentWindow.postMessage('["play"]', "*");
                }

                if (document.querySelector('html').getAttribute('data-scroll') > 145){
                    document.getElementById('player').scrollIntoView({ behavior: 'smooth' });
                }

            }
        }
    });

}



/* ============== PUSH ================= */

// CHECK FOR PUSH BUTTONS ON
if (document.querySelectorAll(".vd-push.on").length > 0){

    let pushSubscription = false;

    const svgPushUnavailable = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bell-slash" viewBox="0 0 16 16"><path d="M5.164 14H15c-.299-.199-.557-.553-.78-1-.9-1.8-1.22-5.12-1.22-6q0-.396-.06-.776l-.938.938c.02.708.157 2.154.457 3.58.161.767.377 1.566.663 2.258H6.164zm5.581-9.91a4 4 0 0 0-1.948-1.01L8 2.917l-.797.161A4 4 0 0 0 4 7c0 .628-.134 2.197-.459 3.742q-.075.358-.166.718l-1.653 1.653q.03-.055.059-.113C2.679 11.2 3 7.88 3 7c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0c.942.19 1.788.645 2.457 1.284zM10 15a2 2 0 1 1-4 0zm-9.375.625a.53.53 0 0 0 .75.75l14.75-14.75a.53.53 0 0 0-.75-.75z"/></svg>`;
    const svgPushAvailable = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bell" viewBox="0 0 16 16"><path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6"/></svg>`;
    const svgPushSubscribed = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bell-fill" viewBox="0 0 16 16"><path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2m.995-14.901a1 1 0 1 0-1.99 0A5 5 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901"/></svg>`;

    // FUNCTION TO UPDATE BUTTONS
    const updateSubButtons = (addClass, removeClass, title, svg) => {
        document.querySelectorAll(".vd-push").forEach(button => {
            if (addClass)               button.classList.add(addClass);
            if (addClass !== "loading") button.classList.remove("loading");
            if (removeClass)            button.classList.remove(removeClass);
            if (title)                  button.title = title;
            if (svg)                    button.innerHTML = svg;
        });
    };

    // SERVICE WORKER AVAILABLE
    if ("serviceWorker" in navigator) {

        // CHECK IF SUBSCRIPTION ALREADY HERE
        navigator.serviceWorker.ready.then(registration => {  
            return registration.pushManager.getSubscription();  
        })  
        .then(subscription => { 
            
            if (subscription) {  

                pushSubscription = subscription;

                // SUBSCRIPTION
                updateSubButtons("subscribed", null, "Se désabonner des notifications", svgPushSubscribed);
            }
            else {
                // NO SUBSCRIPTION
                updateSubButtons(null, "subscribed", "S'abonner aux notifications", svgPushAvailable);
            }
        
        });

    }
    // IMPOSSIBLE PUSH => UPDATE BROWSER
    else {

        updateSubButtons("PushUnavailable", null, "S'abonner aux notifications (mettre à jour votre navigateur)", svgPushUnavailable);

    }

    // ASSIGN CLICK EVENT LISTENER TO BOTH BUTTONS
    document.querySelectorAll(".vd-push").forEach(button => {

        button.addEventListener("click", () => {

            // IF LOADING, STOP ALL
            if (button.classList.contains("loading")) return null;

            // UNAVAILABLE
            if (button.classList.contains("PushUnavailable")) {
                if (confirm("Les notifications ne peuvent être activées en navigation privée ou votre navigateur n'est pas compatible avec les notifications.\nVoulez-vous mettre à jour votre navigateur ?")) {
                    window.open('https://browsehappy.com/', '_blank');
                }
            } 
            // SUBSCRIBE
            else if (!button.classList.contains("subscribed")) {
                updateSubButtons("loading");
                subscribePush()
                    .then(subscription => {
                        if (subscription){
                            pushSubscription = subscription;
                            updateSubButtons("subscribed", null, "Se désabonner des notifications", svgPushSubscribed);
                        }
                        else {
                            updateSubButtons(null, "loading");
                        }
                    })
                    .catch(err => {
                        alert("Les notifications n'ont pas pu être activées.\nMerci d'autoriser les notifications dans votre navigateur.");
                        updateSubButtons();
                        console.error(err)
                    });
            }
            // UNSUBSCRIBE
            else if (button.classList.contains("subscribed")) {
                if (confirm("Vous êtes sur le point de vous désabonner des notifications sur cet appareil.\nMerci de confirmer le désabonnement :")) {              
                    unsubscribePush(pushSubscription)
                        .then(() => {
                            pushSubscription = false;
                            updateSubButtons(null, "subscribed", "S'abonner aux notifications", svgPushAvailable);
                        })
                        .catch(err => console.error(err));
                }
            } 
        });
    });
}
  
// SUBSCRIBE TO PUSH
async function subscribePush() {
    try {
        // Register Service Worker
        const register = await navigator.serviceWorker.register("/sw.js");

        const publicVapidKey = await fetch(core+'/flows/trigger/219faf1f-7204-4917-9fd7-b458085b0e4a')
            .then(response => response.json())
            .then(data => data.vapid_public_key)
            .catch(error => { 
                throw new Error("CORE_INACCESSIBLE");
            });

        if (!publicVapidKey || publicVapidKey == "undefined"){
            throw new Error("VAPID_KEY_MISSING");
        }
    
        // Register Push
        const subscription = await register.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
        });
      
        // Subscribe
        await fetch(core+'/flows/trigger/3038cb6e-c724-489e-8378-1e8742ac3ae2', {
            method: "POST",
            body: JSON.stringify({
                "subscription": subscription,
                "icon": document.querySelector(".gh-head-logo img").getAttribute("src") || null
            }),
            headers: {
                "content-type": "application/json"
            }
        });

        return subscription;

    } catch (error) {
        console.error("Error subscribing to push notifications:", error);
        if (error.message === "CORE_INACCESSIBLE") {
            alert("L'abonnement aux notifications est impossible.\nMerci d'en informer l'administrateur du site.\n\nErreur : Core inaccessible.");
        } else if (error.message === "VAPID_KEY_MISSING") {
            alert("L'abonnement aux notifications est impossible.\nMerci d'en informer l'administrateur du site.\n\nErreur : Vapid key absente.");
        } else if (error.name === "NotAllowedError") {
            alert("Notifications bloquées. Veuillez autoriser les notifications pour ce site dans vos paramètres de navigateur.");
        } else {
            if (navigator.brave && await navigator.brave.isBrave()) {
                alert("Votre navigateur Brave empêche les notifications.\n\nPour les activer, allez dans : Paramètres / Confidentialité et sécurité\n(Ou directement sur cet url : brave://settings/privacy )\n\nPuis cochez :\n'Utiliser les services de Google de messagerie push'");
            }
            else {
                alert("Une erreur inattendue s'est produite. Veuillez réessayer plus tard.");
            }
        }
        return null;   
    }
}

// UNSUBSCRIBE TO PUSH
async function unsubscribePush(subscription){

    await fetch(core+'/flows/trigger/f98df407-c4a1-4a20-a2c6-987b9b469acc', {
        method: "POST",
        body: JSON.stringify(subscription),
        headers: {
            "content-type": "application/json"
        }
    });

    navigator.serviceWorker.ready.then(registration => {
        registration.showNotification("🔕 Notifications désactivées.", {
            body: "Vous ne serez plus notifié sur cet appareil dès qu'un nouveau contenu est publié.",
            icon: document.querySelector(".gh-head-logo img").getAttribute("src") || null
        });
    });

    await subscription
        .unsubscribe()
        .then((successful) => {
            console.log("Unsubscribing successfull.");
        })
        .catch((e) => {
            console.log("Unsubscribing failed.");
        });

}

// CONVERT VAPID
function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, "+")
      .replace(/_/g, "/");
  
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
  
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}


})();